import React from "react";
import Messages_Room_Window_Message from "./Messages_Room_Window_Message";
import {connect} from "react-redux";
import { getRoomMessages } from "../../redux/actions/actions.js";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperclip,faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Messages_Room_Window_Header from "./Messages_Room_Window_Header";

class Messages_Room_Window extends React.Component {
    shouldComponentUpdate(prevProps,prevState) {
        if ((prevProps.second_user !== this.props.second_user) || (prevProps.room_messages !== this.props.room_messages)) {
            return true;
        } else {
            return false;
        }
    }
    componentDidMount() {
        this.interval = setInterval(() => this.props.onGetRoomMessages(this.props.room.id), 3000);
    }
    componentDidUpdate() {
        console.log("update",this.props.second_user.firstName,this.props.second_user.lastName);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
    }
    constructor() {
        super();
        this.state = {
            content: "",
        }
    }
    render() {
        const {user_one_id,user_two_id} = this.props.room;
        const {id} = this.props.user;

        let userFrom, userTo;
        if (user_one_id == id) {
            userFrom = user_one_id;
            userTo = user_two_id;
        } else {
            userFrom = user_two_id;
            userTo = user_one_id;
        }
        const handleSubmit = async(e) => {
            e.preventDefault();
            try {
                console.log(user_one_id,user_two_id,this.state.content,this.props.room.id);
                const response = await axios.post("/newmessage",{
                    user_from_id:userFrom,
                    user_to_id:userTo,
                    content:this.state.content,
                    room_id:this.props.room.id
                },{
                    withCredentials:true,
                    headers:{
                        "Content-Type":"application/json"
                    }
                });
                const result = await axios.put(`/lastroomupdate?q=${this.props.room.id}`,{
                    room_title:"hello"
                });
                console.log("success",result);
            } catch (error) {
                console.log(error);
            }
            this.setState({content:""});
            let input = document.getElementById("messages_window_input");
            input.value = "";
        }
        return(
            <>
                <Messages_Room_Window_Header />
                <div className="messages_room_window_main">
                    {
                        this.props.room_messages.map(item => {
                            return <Messages_Room_Window_Message key={item.id} user_from={item.user_from_id} user_to={item.user_to_id} content={item.content} read={item.read} />
                        })
                    }
                </div>
                <form onSubmit={handleSubmit} className="messages_room_window_form" >
                    <div title="Attach file" className="messages_room_window_form_attach_div">
                        <FontAwesomeIcon className={`messages_room_window_form_attach color_change_${this.props.color_background}`} icon={faPaperclip} />
                    </div>
                    <input id="messages_window_input" onChange={(e) => this.setState({content:e.target.value})} type="text" className={`messages_room_window_form_input profile_edit_form_input_color background_change_${this.props.color_background}`} placeholder="Write a message..."/>
                    {
                        this.state.content.trim() ?
                        <button type="submit" className={`messages_room_window_form_button customizecolorchange_hover customizecolorchange_${this.props.color_button}`}>
                            <FontAwesomeIcon icon={faArrowRight} size="lg" />
                        </button> :
                        <button type="submit" disabled={true} className={`messages_room_window_form_button_disabled customizecolorchange_disabled_${this.props.color_button}`}>
                            <FontAwesomeIcon icon={faArrowRight} size="lg" />
                        </button>
                    }
                </form>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        room: state.getRoom.room,
        room_messages: state.getRoomMessages.room_messages,
        color_button: state.getColorButton.color_button,
        second_user: state.getSecondUser.second_user,
        color_background: state.getColorBackground.color_background,
        user: state.getUser.user
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onGetRoomMessages: (id) => dispatch(getRoomMessages(id))
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Messages_Room_Window);